import {
    AUTO,
    Game,
    Types,
    Scale
} from "phaser";
import {MainScene} from "./scenes/MainScene";
import VirtualJoyStickPlugin from './plugins/virtualjoystick/virtualjoystick-plugin';
import {Constants} from "./Constants";

export class GameStage {

    public game: Game;
    

    private GAME_CONFIG: Types.Core.GameConfig = {
        type: AUTO,
        scale: {
            mode: Scale.FIT,
            autoCenter: Scale.HEIGHT_CONTROLS_WIDTH,
            width: Constants.DEFAULT_WIDTH,
            height: Constants.DEFAULT_HEIGHT
        },
        //width: Constants.DEFAULT_WIDTH,
        //height: Constants.DEFAULT_HEIGHT,
        backgroundColor: "#000000",
        title: 'Cornercard Game',
        scene: [MainScene],
        render: {
        //     pixelArt: true,
        //     antialias: false
            roundPixels: true
        },
        physics: {
            default: "arcade",
            arcade: {
                gravity: {
                    x: 0,
                    y: 0
                },
                fps:80
            }
        },
        input: {
            activePointers: 3 // un pointer per il mouse e due per touch da mobile (joystick e jump)
        },
        plugins: {
            global: [{
                key: 'rexVirtualJoyStick',
                plugin: VirtualJoyStickPlugin,
                start: true
            },
                // ...
            ]
        }
    };

    constructor() {
        this.game = new Game(this.GAME_CONFIG);
    }

    public render(): void {
    }
}
